<template>
  <Page>
    <SidePageColumn side="left">
      <QuickSideLinks :quick_links="quick_links" >
      </QuickSideLinks>
      <!-- <v-divider class="mt-4"></v-divider> -->
      <!-- <FeaturedSidePromotions
        :page="page"
        section="left"
      ></FeaturedSidePromotions> -->
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
        <CenterNavbar
        :crumps="crumps"
        title="View Business"
        :width_class="page_info.center_width_class"
      ></CenterNavbar>
        <OwnerBusinessesView
            :is_loading="is_loading"
            :is_in_admin_view="false"
            :is_in_public_view="true"
            @set-page-attributes="on_set_page_attributes"
            @set-master-page-attrs="set_master_page_attrs"
        >
        </OwnerBusinessesView>
        <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
    <SidePageColumn side="right">
      <SelfPromoAdd :page="page" section="right"></SelfPromoAdd>
      <HomeSideAdsContainer
        :page="page"
        side="right"
        :number_of_ads="3"
      ></HomeSideAdsContainer>
    </SidePageColumn>
  </Page>
</template>

<script>
import Page from "../../components/Page";
import SidePageColumn from "../../components/SidePageColumn";
import FeaturedSidePromotions from "../../components/FeaturedSidePromotions";
import QuickSideLinks from "../../components/QuickSideLinks";
import SelfPromoAdd from "../../components/SelfPromoAdd";
import HomeSideAdsContainer from "../../components/HomeSideAdsContainer";
import CenterPageColumn from "../../components/CenterPageColumn";
import CenterNavbar from "../../components/CenterNavbar";
import Footer from "./../../components/CenterFooter";
import OwnerBusinessesView from "./../business_owner/businesses/OwnerBusinessesView";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";
import page_info from "../../lib/page_info";
export default {
  name: "Business",
  components: {
    Page,
    SidePageColumn,
    OwnerBusinessesView,
    FeaturedSidePromotions,
    QuickSideLinks,
    SelfPromoAdd,
    HomeSideAdsContainer,
    CenterPageColumn,
    CenterNavbar,
    Footer
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
  },
  data: () => ({
    page: "business",
    quick_links: [],
    attrs: Utils.get_default_page_attr(),
    page_info: page_info,
    crumps: []
  }),
  methods: {
    on_set_page_attributes(attrs) {
    //   console.log("I go by top :", attrs);
      this.crumps = attrs.crumps;
    //   if (attrs.right_quick_links) {
    //     this.attrs = attrs;
    //   } else {
    //     this.attrs = {
    //       ...attrs,
    //       right_quick_links: [],
    //     };
    //   }
    },
    set_master_page_attrs(attrs){
         //console.log("Drive that mayback :", attrs);
        this.quick_links = attrs.quick_links;
    }
  },
};
</script>